module.exports = __webpack_public_path__ + "img/logo.848cc795.svg";